import { render, staticRenderFns } from "./ProfileTabsOne.vue?vue&type=template&id=f3cf6c4a&scoped=true&"
import script from "./ProfileTabsOne.vue?vue&type=script&lang=js&"
export * from "./ProfileTabsOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cf6c4a",
  null
  
)

export default component.exports